import { defineComponent as y, computed as u, createBlock as B, openBlock as c, unref as d, normalizeClass as f, createSlots as g, withCtx as s, renderSlot as n, normalizeProps as r, guardReactiveProps as i, createElementVNode as m, createElementBlock as $, createCommentVNode as p, createVNode as b } from "vue";
import { RevButtonIcon as w } from "@ds/components/ButtonIcon";
import { RevModalBase as T } from "@ds/components/ModalBase";
import { RevStickyBar as N } from "@ds/components/StickyBar";
import h from "../../icons/generated/IconArrowLeft.vue2.js";
import { tw as l } from "../../utils/tailwind.js";
const z = { class: "flex h-full flex-col" }, O = {
  key: 0,
  class: "w-full self-end"
}, V = /* @__PURE__ */ y({
  name: "RevDrawer",
  __name: "Drawer",
  props: {
    hasBackButton: { type: Boolean, default: !1 },
    backButtonLabel: { default: "" },
    name: {},
    title: { default: "" },
    closeButtonLabel: { default: () => {
    } },
    hasPadding: { type: Boolean, default: !0 },
    size: { default: "small" },
    to: { default: "body" },
    defer: { type: Boolean, default: !1 },
    backdropZIndex: { default: () => {
    } },
    backgroundColor: { default: "mid" },
    beforeTitleClassNames: { type: [String, Boolean, Array, Object], default: "" },
    afterTitleClassNames: { type: [String, Boolean, Array, Object], default: "" },
    disableCloseOnBackdropClick: { type: Boolean, default: !1 }
  },
  emits: ["open", "close", "back"],
  setup(e) {
    const k = u(() => {
      const t = {
        small: l`md:w-380`,
        medium: l`md:w-640`,
        large: l`md:w-[61rem] md:max-w-full`
      };
      return [
        l`h-full md:rounded-l-lg md:left-auto md:right-0 md:top-0`,
        t[e.size]
      ];
    }), v = {
      enterActiveClass: l`motion-safe:transition-transform motion-safe:duration-300`,
      enterFromClass: l`translate-y-full md:translate-x-full md:translate-y-0`,
      leaveActiveClass: l`motion-safe:transition-transform motion-safe:duration-200`,
      leaveToClass: l`translate-y-full md:translate-x-full md:translate-y-0`
    }, C = u(
      () => e.hasPadding && [l`p-24`, !e.title && l`pt-0`]
    );
    return (t, o) => (c(), B(d(T), {
      "backdrop-z-index": e.backdropZIndex,
      "background-color": e.backgroundColor,
      class: f(k.value),
      "close-button-label": e.closeButtonLabel,
      defer: e.defer,
      "disable-close-on-backdrop-click": e.disableCloseOnBackdropClick,
      "has-body-overflow": !1,
      "has-padding": !1,
      name: e.name,
      title: e.title,
      to: e.to,
      "transition-class-names": v,
      onClose: o[1] || (o[1] = (a) => t.$emit("close", a)),
      onOpen: o[2] || (o[2] = (a) => t.$emit("open"))
    }, g({
      body: s(({ close: a }) => [
        m("div", z, [
          m("div", {
            class: f(["flex-auto overflow-auto", C.value])
          }, [
            n(t.$slots, "body", r(i({ close: a })))
          ], 2),
          t.$slots.footer ? (c(), $("div", O, [
            b(d(N), {
              class: "pb-12",
              position: "bottom",
              "snap-to-view-port": !1
            }, {
              default: s(() => [
                n(t.$slots, "footer", r(i({ close: a })))
              ]),
              _: 2
            }, 1024)
          ])) : p("", !0)
        ])
      ]),
      trigger: s(({ open: a }) => [
        n(t.$slots, "trigger", r(i({ open: a })))
      ]),
      _: 2
    }, [
      e.hasBackButton || t.$slots.beforeTitle ? {
        name: "beforeTitle",
        fn: s(({ close: a }) => [
          m("div", {
            class: f(["absolute left-0", e.beforeTitleClassNames])
          }, [
            n(t.$slots, "beforeTitle", r(i({ close: a })), () => [
              b(d(w), {
                "alternative-text": e.backButtonLabel,
                icon: d(h),
                variant: "secondary",
                onClick: o[0] || (o[0] = (P) => t.$emit("back"))
              }, null, 8, ["alternative-text", "icon"])
            ])
          ], 2)
        ]),
        key: "0"
      } : void 0,
      t.$slots.afterTitle ? {
        name: "afterTitle",
        fn: s(({ close: a }) => [
          m("div", {
            class: f(["absolute right-0 top-0", e.afterTitleClassNames])
          }, [
            n(t.$slots, "afterTitle", r(i({ close: a })))
          ], 2)
        ]),
        key: "1"
      } : void 0
    ]), 1032, ["backdrop-z-index", "background-color", "class", "close-button-label", "defer", "disable-close-on-backdrop-click", "name", "title", "to"]));
  }
});
export {
  V as default
};
